const init = () => {

	const $steps = $('.js-inner-test-step');
	const $items = $('.js-test-item input[type="radio"]');
	let currentQuestion = 0;
	let currentAnswer = 0;
	let currentStep = 0;
	let totalSteps = $steps.length;
	let correctly = [2,4,2,4,1,4,1,2,1,3];
	let result = {
		success: 0,
		fault: 0,
	}

	let residue = $('.inner-test__residue');

	$items.each(function(index) {
		$(this).on("click", function(e) {
			e.preventDefault();

			let step = $(this).closest('.js-inner-test-step');
			let confirmation = $(this).closest('.js-test-item').find('.answer-confirmation');
			let residueThis = $(step).find('.inner-test__residue');

			currentQuestion = $(step).data('step');
			currentAnswer = $(this).val();
			currentStep++;
			
			$(this).attr('checked', 'checked');
			$(step).find('.js-test-item').css("pointerEvents", "none");

			function showConfirmation(questionItem, correct) {
				if (correct === 'right') {
					$(questionItem).addClass('answer-confirmation--success');
					$(questionItem).find('.answer-confirmation__icon').append('<svg><use xlink:href="./images/sprites.svg#success"></use></svg>');
					$(questionItem).find('.answer-confirmation__text').text('Верно!');
					$(questionItem).removeClass('is-hidden');
				} else if (correct === 'wrong') {
					$(questionItem).addClass('answer-confirmation--wrong');
					$(questionItem).find('.answer-confirmation__icon').append('<svg><use xlink:href="./images/sprites.svg#wrong"></use></svg>');
					$(questionItem).find('.answer-confirmation__text').text('Неверно!');
					$(questionItem).removeClass('is-hidden');
				}
			}

			if (correctly[currentQuestion - 1] === +currentAnswer) {
				result.success += 1;
				showConfirmation(confirmation, 'right');

			} else {
				let rightItem = $(step).find('.inner-test__list .item')[correctly[currentQuestion - 1] - 1];
				let rightConfirm = $(rightItem).closest('.js-test-item').find('.answer-confirmation');

				result.fault += 1;
				showConfirmation(confirmation, 'wrong');
				showConfirmation(rightConfirm, 'right');
			}

			residue.each(function(index) {
				$(this).find('.inner-test__residue-current').text(`${totalSteps - currentStep}`);
			});

			$(residueThis).removeClass('is-hidden');

			if (totalSteps === currentStep) {
				if (result.success < 5) {
					$('a.map__result-button').attr('data-modal-id', 'result1');
				} else if ((5 <= result.success) && (result.success <= 7)) {
					$('a.map__result-button').attr('data-modal-id', 'result2');
				} else if (result.success >= 8) {
					$('a.map__result-button').attr('data-modal-id', 'result3');
				}

				$('.map__result').removeClass('is-hidden');
			}

			console.log(result);
		});
	});

	$('.js-map-result-close').on("click", function() {
		$(this).closest('.map__result').addClass('is-hidden');
	});

};

export default {
	init,
};
